"use client"

import { useMemo } from "react"
import NotFound from "../app/[locale]/not-found"
import { BatchDataMap, BatchDataProvider } from "../lib/batch-data-context"
import { tryParse } from "../lib/config/lib/helper"
import { generateImagePath } from "../lib/utils"
import BreadCrumb, { BreadCrumbItem } from "./breadcrumb"
import PuckIsland from "./puck-island.client"
import StandardPageContent from "./standard-page-content"

interface PageData {
  id: number
  attributes: {
    slug: string
    id: string
    content: string
    blockContent: any
    name: string
    locale?: string
    isUseUIBuilder?: boolean
    image?: {
      data?: {
        attributes?: {
          url?: string
        }
      }
    }
  }
}

interface PageRenderProps {
  pageData?: PageData[]
  hasBreadcrumb?: boolean
  isTemplate?: boolean
  dict?: any
  base_url?: string
  batchData?: BatchDataMap
}

const PageRender = ({ pageData, hasBreadcrumb, isTemplate, batchData }: PageRenderProps) => {
  const page = pageData?.[0]
  const slug = page?.attributes?.slug
  const normalContent = page?.attributes?.content
  const imageUrl = page?.attributes?.image?.data?.attributes?.url

  const uiBuilderData = useMemo(() => {
    if (!page || (!isTemplate && !page.attributes?.isUseUIBuilder)) return null

    const content = isTemplate
      ? page.attributes?.content
      : page.attributes?.blockContent?.data?.attributes?.content

    return tryParse(content ?? "")
  }, [isTemplate, page])

  const renderContent = () => {
    if (uiBuilderData) {
      const titleCurrentPage = uiBuilderData?.root?.props?.title
      const customBreadcrumbs = uiBuilderData?.root?.props?.breadcrumb
      const hasCustomBreadcrumbs = customBreadcrumbs?.length > 0

      const breadcrumbItems =
        customBreadcrumbs?.map((item: BreadCrumbItem) => ({
          title: item?.title,
          link: item?.link ?? "#",
        })) ?? []

      const currentPageLink = hasCustomBreadcrumbs
        ? `${breadcrumbItems.map((item: BreadCrumbItem) => item.link).join("/")}/${slug}`
        : `/${slug}`

      const breadcrumbConfig = [
        ...breadcrumbItems,
        {
          title: titleCurrentPage,
          link: currentPageLink,
        },
      ]

      return (
        <>
          {hasBreadcrumb && <BreadCrumb items={breadcrumbConfig} />}
          <PuckIsland data={uiBuilderData} minHeight="100vh" />
        </>
      )
    }

    if (normalContent) {
      return (
        <StandardPageContent
          content={normalContent}
          locale={page?.attributes?.locale}
          title={page?.attributes?.name ?? ""}
          coverUrl={imageUrl ? generateImagePath(imageUrl, "large") : undefined}
        />
      )
    }

    return <NotFound />
  }

  return <BatchDataProvider data={batchData}>{renderContent()}</BatchDataProvider>
}

export default PageRender
